import * as Dialog from '@radix-ui/react-dialog';

import { styled } from '@lichtblick/styled';
import { Colors } from '@lichtblick/theme';

export const DrawerPanelOverlay = styled(Dialog.Overlay)`
  background: rgba(0, 0, 0, 0.3);
  inset: 0;
  position: fixed;
  z-index: var(--z-index-panel-overlay);

  &[data-state='open'] {
    animation: drawerPanelOverlayShow 150ms ease-in-out;
  }

  &[data-state='closed'] {
    animation: drawerPanelOverlayHide 150ms ease-in-out;
  }

  @keyframes drawerPanelOverlayShow {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes drawerPanelOverlayHide {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;

export const DrawerPanelContent = styled(Dialog.Content)<{ $side: 'left' | 'right'; $widthOverride?: string }>`
  background-color: ${Colors.white};
  bottom: 0;
  box-shadow: ${({ $side }) =>
    $side === 'left' ? '2px 0 16px rgba(0, 0, 0, 0.12)' : '-2px 0 16px rgba(0, 0, 0, 0.12)'};
  display: flex;
  flex-direction: column;
  ${({ $side }) => ($side === 'left' ? 'left: 0;' : 'right: 0;')}
  max-width: ${({ $widthOverride }) => $widthOverride ?? '48rem'};
  overflow: hidden;
  position: fixed;
  top: 0;
  width: ${({ $widthOverride }) => $widthOverride ?? '75%'};
  will-change: transform;
  z-index: var(--z-index-panel-drawer);

  &[data-state='open'] {
    animation: ${({ $side }) => ($side === 'left' ? 'drawerSlideInFromLeft' : 'drawerSlideInFromRight')} 0.3s
      cubic-bezier(0.4, 0, 0.2, 1);
  }

  &[data-state='closed'] {
    animation: ${({ $side }) => ($side === 'left' ? 'drawerSlideOutToLeft' : 'drawerSlideOutToRight')} 0.3s
      cubic-bezier(0.4, 0, 0.2, 1);
  }

  @keyframes drawerSlideInFromRight {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes drawerSlideOutToRight {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(100%);
    }
  }

  @keyframes drawerSlideInFromLeft {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes drawerSlideOutToLeft {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-100%);
    }
  }
`;
